import React, { useState } from 'react';
import { CalendarDays, Clock, Users, MessageSquare, ArrowLeft, Check, Phone, Mail, User } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ReservationPage = () => {
  const [form, setForm] = useState({
    name: '', email: '', phone: '', date: '', time: '19:00', guests: 2, notes: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const today = new Date().toISOString().split('T')[0];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.date || !form.time) return;
    setLoading(true);
    try {
      await axios.post(`${API}/reservations`, form);
      setSubmitted(true);
    } catch (err) {
      alert('Erreur lors de la reservation');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen bg-[#0D0D0D] flex items-center justify-center p-4">
        <div className="bg-[#1A1A1A] rounded-3xl p-8 max-w-md w-full text-center border border-[#333]">
          <div className="w-16 h-16 bg-[#2D6A4F] rounded-full flex items-center justify-center mx-auto mb-4">
            <Check className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-[#D4A853] mb-2">Reservation envoyee !</h1>
          <p className="text-[#A0A0A0] mb-4">
            Merci {form.name}. Votre reservation pour {form.guests} personne{form.guests > 1 ? 's' : ''} le {form.date} a {form.time} a ete envoyee.
          </p>
          <p className="text-sm text-[#6E5E52]">Nous vous confirmerons par email ou telephone.</p>
          <a href="/" className="block mt-6 text-[#D4A853] hover:underline text-sm" data-testid="back-home">
            Retour a l'accueil
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0D0D0D] p-4">
      <div className="max-w-md mx-auto">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6 pt-4">
          <a href="/" className="w-9 h-9 rounded-full bg-[#1A1A1A] border border-[#333] flex items-center justify-center text-[#D4A853]">
            <ArrowLeft className="w-4 h-4" />
          </a>
          <div>
            <h1 className="text-xl font-bold text-[#D4A853]">Reserver une table</h1>
            <p className="text-xs text-[#A0A0A0]">HIBISUN - Patong, Phuket</p>
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="bg-[#1A1A1A] rounded-3xl p-6 border border-[#333] space-y-4">
          <div>
            <label className="text-sm font-medium text-[#D4A853] mb-1 flex items-center gap-1">
              <User className="w-3 h-3" /> Nom
            </label>
            <Input value={form.name} onChange={e => setForm({...form, name: e.target.value})}
              placeholder="Votre nom" required
              className="rounded-xl bg-[#0D0D0D] border-[#333] text-white placeholder:text-[#666]"
              data-testid="res-name" />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-sm font-medium text-[#D4A853] mb-1 flex items-center gap-1">
                <Mail className="w-3 h-3" /> Email
              </label>
              <Input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})}
                placeholder="email@..." className="rounded-xl bg-[#0D0D0D] border-[#333] text-white placeholder:text-[#666]"
                data-testid="res-email" />
            </div>
            <div>
              <label className="text-sm font-medium text-[#D4A853] mb-1 flex items-center gap-1">
                <Phone className="w-3 h-3" /> Telephone
              </label>
              <Input type="tel" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})}
                placeholder="+66..." className="rounded-xl bg-[#0D0D0D] border-[#333] text-white placeholder:text-[#666]"
                data-testid="res-phone" />
            </div>
          </div>

          <div className="grid grid-cols-3 gap-3">
            <div>
              <label className="text-sm font-medium text-[#D4A853] mb-1 flex items-center gap-1">
                <CalendarDays className="w-3 h-3" /> Date
              </label>
              <Input type="date" value={form.date} onChange={e => setForm({...form, date: e.target.value})}
                min={today} required
                className="rounded-xl bg-[#0D0D0D] border-[#333] text-white"
                data-testid="res-date" />
            </div>
            <div>
              <label className="text-sm font-medium text-[#D4A853] mb-1 flex items-center gap-1">
                <Clock className="w-3 h-3" /> Heure
              </label>
              <Input type="time" value={form.time} onChange={e => setForm({...form, time: e.target.value})}
                required className="rounded-xl bg-[#0D0D0D] border-[#333] text-white"
                data-testid="res-time" />
            </div>
            <div>
              <label className="text-sm font-medium text-[#D4A853] mb-1 flex items-center gap-1">
                <Users className="w-3 h-3" /> Pers.
              </label>
              <Input type="number" min="1" max="20" value={form.guests}
                onChange={e => setForm({...form, guests: parseInt(e.target.value) || 2})}
                className="rounded-xl bg-[#0D0D0D] border-[#333] text-white"
                data-testid="res-guests" />
            </div>
          </div>

          <div>
            <label className="text-sm font-medium text-[#D4A853] mb-1 flex items-center gap-1">
              <MessageSquare className="w-3 h-3" /> Notes
            </label>
            <Textarea value={form.notes} onChange={e => setForm({...form, notes: e.target.value})}
              placeholder="Anniversaire, allergies, demande speciale..."
              className="rounded-xl bg-[#0D0D0D] border-[#333] text-white placeholder:text-[#666] min-h-[60px]"
              data-testid="res-notes" />
          </div>

          <Button type="submit" disabled={loading || !form.name || !form.date}
            className="w-full bg-gradient-to-r from-[#D4A853] to-[#C4983F] text-black rounded-full font-semibold py-3"
            data-testid="res-submit">
            {loading ? 'Envoi...' : 'Reserver'}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default ReservationPage;
